import React, { useMemo } from "react"

import Main from "./Main"

const MainByDomain = () => {
    const { doctor_id } = window

    const match = useMemo(() => {
        return {
            params: {
                id: doctor_id,
            },
        }
    }, [doctor_id])

    return <Main match={match} />
}

export default MainByDomain
